import React from "react";

/**
 * Ask Dai icon — uses the Diverse Integration logo to match the sidebar branding.
 */
export default function AskDaiIcon({ className = "w-12 h-12" }) {
  return (
    <img
      data-decorative-image="true"
      src="/diverse-integration-logo.png"
      alt="Ask Dai — Diverse Integration"
      className={`${className} object-contain`}
    />
  );
}
